import { string, date, number, object } from  'yup';

export const createSchema = object().shape({
    unit: string().required(),
    ipAddress: string().required(),
    createdAt: date().required(),
    createdBy: string().email().required(),
    modifiedAt: date().required(),
    modifiedBy: string().email().required(),
    notes: string().notRequired().nullable()
});

export const updateSchema = createSchema.shape({
    id: number().required()
});